/**
 * Scoring Admin API Endpoints
 * Tunable knobs for the cross-adventure score ladders (Admin API).
 *
 * `/admin/*` paths are rewritten to the Admin API's `/api/*` — see api/client.ts.
 */

import { ApiService } from '../apiService'
import type { ScoringOptionsResponse, UpdateScoringOptionsRequest } from '../types/scoring'

export const scoringApi = {
  /** Current effective knobs, the compiled defaults, per-knob metadata and override provenance. */
  getOptions: () => ApiService.get<ScoringOptionsResponse>('/admin/scoring/options'),

  /**
   * Replaces all nine knobs. Does not trigger a recompute — the response's `requiresRecompute`
   * flags that standings are now stale until one is run.
   */
  updateOptions: (request: UpdateScoringOptionsRequest) =>
    ApiService.put<ScoringOptionsResponse>('/admin/scoring/options', request),

  /** Removes every stored override, returning all knobs to the compiled defaults. */
  resetOptions: () => ApiService.post<ScoringOptionsResponse>('/admin/scoring/options/reset'),
}
